import { Box } from '@mui/material';

/**
 * The "nothing has happened yet" lead: an unbooked labour item is the plot's
 * price book, not an error, so it gets an outline rather than a colour.
 */
export const HollowDot = () => (
  <Box
    component="span"
    aria-hidden
    sx={{
      display: 'inline-block',
      width: 8,
      height: 8,
      borderRadius: '50%',
      border: '1.5px solid',
      borderColor: 'text.disabled',
      boxSizing: 'border-box',
      flexShrink: 0,
    }}
  />
);
